import {initializeApp} from 'firebase/app';
import {
    getAuth,
    signInWithPopup,
    GoogleAuthProvider,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    onAuthStateChanged,
} from 'firebase/auth';
import {getFirestore, doc, getDoc, setDoc, collection, writeBatch, query, getDocs} from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAqzYQWn9kiZ0qi0XAtjEVWA7HGHdWMdBs",
    authDomain: "crown-clothing-46719.firebaseapp.com",
    projectId: "crown-clothing-46719",
    storageBucket: "crown-clothing-46719.appspot.com",
    messagingSenderId: "1044048581905",
    appId: "1:1044048581905:web:a3eb5acbc9cc503566a8b0",
    measurementId: "G-PS7TTJ6T8Q"
};
// Initialize Firebase
initializeApp(firebaseConfig);
const provider = new GoogleAuthProvider();

provider.setCustomParameters({
    prompt: "select_account"
});

export const auth = getAuth();
export const signInWithGooglePopup = async () => {
    const userAuth = await signInWithPopup(auth, provider);
    await createUserDocumentFromAuth(userAuth);
    return userAuth;
};

export const db = getFirestore();

export const addCollectionAndDocuments = async (collectionKey, objectsToAdd) => {
    const collectionRef = collection(db, collectionKey);
    const batch = writeBatch(db);

    objectsToAdd.forEach((object) => {
        const docRef = doc(collectionRef, object.title.toLowerCase());
        batch.set(docRef, object);
    })

    await batch.commit();
    console.log('Done');
}

export const getCollectionAndDocuments = async () => {
    const collectionRef = collection(db, 'categories');
    const q = query(collectionRef);

    const querySnapShot = await getDocs(q);
    const categoryMap = querySnapShot.docs.reduce((acc, docSnapshot) => {
        const { title, items } = docSnapshot.data();
        acc[title.toLowerCase()] = items;
        return acc;
    }, {})

    return categoryMap;
}

export const createUserDocumentFromAuth = async (userAuth, additionalInformation = {}) => {
    if (!userAuth || !userAuth.user) {
        return;
    }

    const { uid, displayName, email } = userAuth.user;
    const userDocRef = doc(db, 'users', uid);

    const userSnapShot = await getDoc(userDocRef);

    if (!userSnapShot.exists()) {
        const createdAt = new Date();

        try {
            await setDoc(userDocRef, {
                displayName,
                email,
                createdAt,
                ...additionalInformation,
            });
        } catch (e) {
            console.log("Error creating user", e.message);
        }
    }

    return userDocRef;
}

export const createAuthUserWithEmailAndPassword = async (email, password) => {
    if (!email || !password) return;

    try {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        return userCredential;
    } catch (error) {
        throw error;
    }
}

export const signOutUser = async () => await signOut(auth);

export const signInAuthUserWithEmailAndPassword = async  (email, password) => {
    if (!email || !password) return;

    return await signInWithEmailAndPassword (auth, email, password);
}

export const onAuthStateChangedListener = (callback) => onAuthStateChanged(auth, callback);
